import { createContext, useMemo, useState } from 'react'
import type { PropsWithChildren } from 'react'

interface CalendarBurnContextValue {
  enabled: boolean
  setEnabled: (enabled: boolean) => void
}

export const CalendarBurnContext = createContext<CalendarBurnContextValue>({
  enabled: false,
  setEnabled: () => {},
})

export function CalendarBurnProvider({ children }: PropsWithChildren) {
  const [enabled, setEnabled] = useState(false)
  const value = useMemo(() => ({ enabled, setEnabled }), [enabled])
  return <CalendarBurnContext.Provider value={value}>{children}</CalendarBurnContext.Provider>
}
